/**
 * Table modules aggregation.
 * Add new table modules to the `tableModules` array.
 */

import { defineMutators } from "@rocicorp/zero";

import type { ExtractMutators } from "./table-module";
import { habitNutritionFoodModule } from "./habit-nutrition-food";
// TODO: Re-enable user module once user table is deployed to Zero server
// import { userModule } from "./user";

export const tableModules = [habitNutritionFoodModule] as const;

type MutatorsConfig = ExtractMutators<typeof tableModules>;
const mutatorsConfig = Object.fromEntries(
  tableModules.map((m) => [m.name, m.mutators])
) as MutatorsConfig;

export const mutators = defineMutators(mutatorsConfig);

/** Mutator definitions type for Zero client typing. */
export type MutatorDefs = MutatorsConfig;

/** Runtime mutators type (result of defineMutators). */
export type Mutators = typeof mutators;

export type * from "./types";
